<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal" 
         role="dialog" 
         aria-labelledby="upgrade-modal-title"
         aria-describedby="upgrade-modal-description">
      
      <!-- Header -->
      <div class="modal-header">
        <h3 id="upgrade-modal-title" class="modal-title">Opções de Upgrade</h3>
        <button mat-icon-button 
                (click)="close()"
                aria-label="Fechar modal de opções de upgrade">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Body -->
      <mat-dialog-content id="upgrade-modal-description" class="modal-body">
        <!-- Região de anúncios dinâmicos para screen readers -->
        <div aria-live="polite" aria-atomic="true" class="sr-only">
          <span *ngIf="loading">Carregando opções de upgrade...</span>
          <span *ngIf="error">Erro: {{ error }}</span>
          <span *ngIf="!loading && !error && upgradeOptions?.availableUpgrades?.length === 0">
            Não há opções de upgrade disponíveis
          </span>
          <span *ngIf="!loading && !error && upgradeOptions && upgradeOptions.availableUpgrades && upgradeOptions.availableUpgrades.length > 0">
            {{ upgradeOptions.availableUpgrades.length }} opções de upgrade disponíveis
          </span>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="spinner-container" role="status" aria-label="Carregando opções de upgrade">
          <mat-progress-spinner diameter="40" mode="indeterminate" aria-hidden="true"></mat-progress-spinner>
          <p>Carregando opções de upgrade...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error" class="alert alert-error" role="alert">
          <mat-icon aria-hidden="true">error</mat-icon>
          <div>{{ error }}</div>
        </div>

        <!-- Success State -->
        <div *ngIf="!loading && !error && upgradeOptions">
          <!-- Informações do Plano Atual -->
          <div class="current-plan-section">
            <h4>Seu Plano Atual</h4>
            <div class="current-plan-info">
              <div class="info-row">
                <span class="info-label">Plano:</span>
                <span class="info-separator"></span>
                <span class="info-data">{{ upgradeOptions.currentPlanName }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Valor Mensal:</span>
                <span class="info-separator"></span>
                <span class="info-data">{{ upgradeOptions.currentPlanValue | currency:'BRL':'symbol':'1.2-2' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Categoria:</span>
                <span class="info-separator"></span>
                <span class="info-data">{{ upgradeOptions.category }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Tipo de Pacote:</span>
                <span class="info-separator"></span>
                <span class="info-data">{{ upgradeOptions.currentPackageType }}</span>
              </div>
            </div>
            
            <!-- Badges de Status -->
            <div class="status-badges">
              <span *ngIf="upgradeOptions.hasExternalPayer" class="badge badge-primary">
                <mat-icon>business</mat-icon>
                Plano com Pagador Externo
              </span>
              <span *ngIf="upgradeOptions.inTrialPeriod" class="badge badge-warning">
                <mat-icon>schedule</mat-icon>
                Período Trial
              </span>
            </div>
          </div>

          <!-- Empty State -->
          <div *ngIf="upgradeOptions.availableUpgrades?.length === 0" class="alert alert-info" role="status">
            <mat-icon aria-hidden="true">info</mat-icon>
            <div>
              <strong>Não há opções de upgrade disponíveis</strong>
              <p>Você já possui o melhor plano disponível para sua categoria.</p>
            </div>
          </div>

          <!-- Upgrade Options Grid -->
          <div *ngIf="upgradeOptions.availableUpgrades && upgradeOptions.availableUpgrades.length > 0" 
               class="upgrade-options-grid"
               role="list"
               aria-label="Lista de opções de upgrade disponíveis">
            <div *ngFor="let option of upgradeOptions.availableUpgrades; trackBy: trackByPackageId" 
                 class="upgrade-card card"
                 role="listitem">
              
              <!-- Card Header -->
              <div class="card-header">
                <h5 class="card-title">{{ option.name }}</h5>
              </div>
              
              <!-- Card Body -->
              <div class="card-body">
                <p class="upgrade-description">{{ option.description }}</p>
                
                <!-- Pricing Information -->
                <div class="upgrade-pricing" role="region" aria-label="Informações de preço">
                  <div class="price-current">
                    <span class="price-label">Valor Atual:</span>
                    <span class="price-value">{{ option.currentPlanValue | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </div>
                  <div class="price-upgrade">
                    <span class="price-label">Novo Valor:</span>
                    <span class="price-value price-highlight">{{ option.upgradePlanValue | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </div>
                  <div class="price-difference">
                    <span class="price-label">Diferença:</span>
                    <span class="price-value price-difference-value">
                      +{{ option.valueDifference | currency:'BRL':'symbol':'1.2-2' }}
                    </span>
                  </div>
                </div>

                <!-- Capacity Increase (conditional) -->
                <div *ngIf="option.capacityIncrease && option.capacityIncrease > 0" 
                     class="capacity-info"
                     role="note"
                     aria-label="Aumento de capacidade">
                  <mat-icon aria-hidden="true">trending_up</mat-icon>
                  <span>+{{ option.capacityIncrease }} profissionais/conexões</span>
                  <span class="sr-only">Aumento de {{ option.capacityIncrease }} profissionais ou conexões</span>
                </div>

                <!-- Additional Benefits (conditional) -->
                <div *ngIf="option.additionalBenefits && option.additionalBenefits.length > 0" 
                     class="benefits-list">
                  <h6>Benefícios Adicionais:</h6>
                  <ul role="list" aria-label="Lista de benefícios adicionais">
                    <li *ngFor="let benefit of option.additionalBenefits" role="listitem">
                      <mat-icon aria-hidden="true">check_circle</mat-icon>
                      <span class="sr-only">Benefício incluído:</span>
                      {{ benefit }}
                    </li>
                  </ul>
                </div>
              </div>
              
              <!-- Card Footer -->
              <div class="card-footer">
                <button mat-raised-button 
                        color="primary" 
                        class="btn btn-primary btn-full-line"
                        (click)="selectUpgrade(option)"
                        [attr.aria-label]="'Selecionar plano ' + option.name + ' por ' + (option.upgradePlanValue | currency:'BRL':'symbol':'1.2-2')">
                  Selecionar Plano
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>

      <!-- Footer -->
      <mat-dialog-actions class="modal-footer">
        <button mat-button class="btn btn-ghost" (click)="close()">
          Fechar
        </button>
      </mat-dialog-actions>
      
    </div>
  </div>
</div>
